export const LOGIN_SUCCEED = 'LOGIN_SUCCEED'
export const SET_USER_ACCOUNT = 'SET_USER_ACCOUNT'
export const GET_SCORE_RECORDS = 'GET_SCORE_RECORDS'
export const GET_REPORT_RECORD_LIST = 'GET_REPORT_RECORD_LIST'
export const GET_OVERALL_ANALYSIS = 'GET_OVERALL_ANALYSIS'
export const SET_PINGCE_USER_INFO = 'SET_PINGCE_USER_INFO'
export const GET_REPORT_EXCEL_INFO = 'GET_REPORT_EXCEL_INFO'
export const SET_REPORT_NUMBER = 'SET_REPORT_NUMBER'
export const GET_PINGCE_EXCEL = 'GET_PINGCE_EXCEL'
export const SET_REPORT_ANALYZE = 'SET_REPORT_ANALYZE'
export const REST_ZYPC_STORE = 'REST_ZYPC_STORE'
export const GET_RANKING_BY_SCORE = 'GET_RANKING_BY_SCORE'
export const GET_USER_HOT_DEGREE = 'GET_USER_HOT_DEGREE'
